var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-box"},[_c('small',{staticClass:"detail-box__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"detail-box__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }